import React from "react";
import { useTranslation } from "react-i18next";

export const Trust = () => {
  const { t } = useTranslation();
  return (
    <section className="border-y border-[var(--rule)] bg-[var(--bg-paper-deep)]/60">
      <div className="max-w-5xl mx-auto px-6 py-20 grid md:grid-cols-3 gap-12">
        <div className="md:col-span-1">
          <h3 className="font-display text-2xl tracking-tight text-[var(--ink)]">{t("trust.promise")}</h3>
        </div>
        <div className="md:col-span-2 space-y-5 text-[var(--ink-soft)] text-[17px] leading-[1.9]">
          <p data-testid="trust-p1">— {t("trust.p1")}</p>
          <p data-testid="trust-p2">— {t("trust.p2")}</p>
          <p data-testid="trust-p3">— {t("trust.p3")}</p>
        </div>
      </div>
    </section>
  );
};
